<form [formGroup]="formGroup" class="support-form flex-col-start">
  <div class="form-field">
    <markant-input
      outlined="true"
      data-cy="login-error-form-email"
      id="login-error-form-email"
      formControlName="email"
      placeholder="email@example.com"
      type="email"
      required
      [label]="('common.email' | transloco) + '*'"
      [error]="
        formGroup.controls['email'].errors
          | formControlError: isTouched('email')
      "
      [errorText]="
        formGroup.controls['email'].errors?.['required']
          ? ('error.validation.required' | transloco)
          : formGroup.controls['email'].errors?.['email']
            ? ('error.validation.email' | transloco)
            : null
      "
    ></markant-input>
  </div>
  <div class="form-field">
    <markant-input
      outlined="true"
      data-cy="login-error-form-organization-name"
      id="login-error-form-organization-name"
      formControlName="companyName"
      type="text"
      required
      [placeholder]="'common.organization' | transloco"
      [label]="('auth.organizationName' | transloco) + '*'"
      [error]="
        formGroup.controls['companyName'].errors
          | formControlError: isTouched('companyName')
      "
      [errorText]="
        formGroup.controls['companyName'].errors
          ? ('error.validation.required' | transloco)
          : null
      "
    ></markant-input>
  </div>
  <div class="form-field">
    <markant-input
      outlined="true"
      data-cy="login-error-form-gln"
      id="login-error-form-gln"
      formControlName="gln"
      placeholder="12345670000000"
      type="text"
      maxlength="13"
      [error]="
        formGroup.controls['gln'].errors
          | formControlError
            : formGroup.controls['gln'].touched ||
                formGroup.controls['gln'].dirty
      "
      [errorText]="
        formGroup.controls['gln'].errors
          | formControlKeyError
            : 'organization.details.fields.gln.validation'
            : formGroup.controls['gln'].touched ||
                formGroup.controls['gln'].dirty
          | transloco
      "
      [label]="'auth.GLN' | transloco"
    ></markant-input>
  </div>

  <div class="form-field">
    <markant-textarea
      data-cy="login-error-form-description"
      id="login-error-form-description"
      formControlName="description"
      cols="60"
      rows="4"
      outlined="true"
      minlength="0"
      maxlength="180"
      [placeholder]="'common.problemDescription' | transloco"
      [label]="('common.description' | transloco) + '*'"
      [error]="
        formGroup.controls['description'].errors
          | formControlError: isTouched('description')
      "
      [helperValidation]="true"
      [helper]="
        formGroup.controls['description'].errors
          ? ('error.validation.required' | transloco)
          : ''
      "
      required
    ></markant-textarea>
  </div>

  <div class="form-actions flex-row-end">
    <markant-button
      id="login-error-form-cancel"
      data-cy="login-error-form-cancel"
      colorScheme="primary"
      variant="clear"
      (click)="onCancel()"
    >
      {{ 'common.cancel' | transloco }}
    </markant-button>
    <markant-button
      id="login-error-form-submit"
      data-cy="login-error-form-submit"
      colorScheme="primary"
      [loading]="loading"
      (click)="onSubmit()"
    >
      {{ 'common.send' | transloco }}
    </markant-button>
  </div>
</form>
